import "../../assets/scss/components/toolbar.scss";
import styled from "styled-components";
import { SearchBar } from "./searchbar";
import useAuth from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import moment from "moment";

export const Toolbar: React.FC = () => {
  const Container = styled.nav``;
  const { user } = useAuth() as any;
  const [info, setInfo] = useState({
    country: "Germany",
    city: "Berlin",
    time: moment().format("hh:mm a"),
    temperature: 16,
    weather: "ok",
  });

  const initialise = async () => {
    if (user && user.geo_info.country != null) {
      await setInfo({
        country: user.geo_info?.country,
        city: user.geo_info?.city,
        temperature: user.geo_info?.temperature,
        weather: user.geo_info?.weather,
        time: user.geo_info.time ? moment(user.geo_info.time).format("hh:mm a") : moment().format("hh:mm a"),
      });
    }
  }
  useEffect(() => {
    if (user) initialise();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  return (
    <Container className="uk-container force-stratch-width d-flex toolbar">
      <div className="card-location" style={{ display: user ? "block" : "none" }}>
        <div>
          <strong>{info.city && `${info.city}, `}</strong> {info.country}
        </div>
        <div>
          {info.time.toUpperCase()} {info.temperature}°C
          <img className="mb-1 ms-2" src={
            "weather_icons/" + (
              info.weather?.toLowerCase() === "rain" ||
                info.weather?.toLowerCase() === "snow" ||
                info.weather?.toLowerCase() === "clouds" ||
                info.weather?.toLowerCase() === "wind" ?
                info.weather?.toLowerCase() : "sun"
            ) + ".png"
          } style={{ width: '20px' }} alt="" />
        </div>
      </div>
      <SearchBar/>
    </Container>
  );
};
